import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Interface_updateRecord extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_interface_updaterecord">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Interface.updateRecord</h2>
              <p>
                NL.Interface.updateRecord is a simple method that allows you to
                update the Nexoid App interface and database. The
                NL.Interface.updateRecord has three parmaters. "data" which is
                the record data you want to update, "updateDB" which allows you
                to update or not update the database and "dontEval" which allows
                you to bypass the Nexoid Application events like hide_if and
                on_change.
              </p>
              <WorkflowCompatibility front={true} back={false} />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Interface.updateRecord</h2>
              <p>
                This example will update the record value text_name to "Jon" and
                will update the database and run any evals after the update.
              </p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">recordData</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">text_name</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">Jon</span>
                  <span className="jsonA">"</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>

                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">updateDB</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonPink">true</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">dontEval</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonPink">false</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Interface</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">updateRecord</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">recordData</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">updateDB</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">dontEval</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Interface_updateRecord;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Interface_updateRecord.js